import React from 'react';
export const QuestionItemSkeleton = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "question-item__container" },
            React.createElement("div", { className: "question-item__content" },
                React.createElement("div", { className: "h4__skeleton" }),
                React.createElement("div", { className: "question-item__options" },
                    React.createElement("div", { className: "text__skeleton" }),
                    React.createElement("div", { className: "text__skeleton" }),
                    React.createElement("div", { className: "text__skeleton" }),
                    React.createElement("div", { className: "text__skeleton" })),
                React.createElement("div", { className: "question-item__answer" },
                    React.createElement("div", { className: "text__skeleton" }))),
            React.createElement("div", { className: "question-item__controls" },
                React.createElement("button", { className: "btn__skeleton--primary" }),
                React.createElement("button", { className: "btn__skeleton--secondary" })))));
};
